import { render, staticRenderFns } from "./AccidentReportsPanel.vue?vue&type=template&id=e7af6b34&scoped=true"
import script from "./AccidentReportsPanel.vue?vue&type=script&lang=js"
export * from "./AccidentReportsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7af6b34",
  null
  
)

export default component.exports